import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import { HorizonEventTemplatesModule } from '@/modules/horizon/event-templates/horizon-event-templates-module';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

/**
 * URL search params for the Event Templates list page.
 * List filters are optional; sheet/delete params appear only when the sheet or delete dialog is open.
 */
const searchSchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().default(10),
  search: z.string().optional(),
  category: z.string().optional(),
  status: z.enum(['APPROVED', 'REQUESTED', 'REJECTED']).optional(),
  sheet: z.enum(['create', 'edit', 'view']).optional(),
  id: z.string().optional(),
  sheetKey: z.coerce.number().optional(),
  delete: z.string().optional(),
});

export const Route = createFileRoute('/dashboard/horizon/event-templates/')({
  validateSearch: searchSchema,
  component: HorizonEventTemplatesPage,
});

function HorizonEventTemplatesPage() {
  const { canAccessHorizonTemplateRequests } = useAccessControl();
  if (!canAccessHorizonTemplateRequests) {
    return <AccessDenied />;
  }
  return <HorizonEventTemplatesModule />;
}
